import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { fetchUserSubscription } from "../../utils/apiRoutes";
import { useSelector, useDispatch } from 'react-redux';
import { setSubscription } from '../../redux/userSlice';
import { useNavigate } from 'react-router-dom';
import { PrimaryBtn } from '../Assets/Buttons';
import AuthLayout from '../Assets/AuthLayout';
import { isSubActive } from '../../utils/user';

const Subscribed = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const [sessionId, setSessionId] = useState(searchParams.get("session_id") || null);
    const userId = useSelector((state) => state.user.id);
    const navigate = useNavigate();

    useEffect(() => {
        const updateSubscription = async () => {
            const subPayload = await fetchUserSubscription(userId);
            const { isActive } = isSubActive(subPayload);
            dispatch(setSubscription({ subscription: subPayload, isActive }));
        };

        if (sessionId !== null) {
            updateSubscription();
        }
    }, [sessionId, dispatch, userId]);

    return (
        <AuthLayout>
            <div className="w-full max-w-md">
                <div className="text-center">
                    {/* LineLeaders Logo */}
                    <div className="mx-auto h-24 w-24 mb-6">
                        <svg viewBox="0 0 197.14 186.94" className="w-full h-full">
                            <path 
                                fill="#db0632"
                                d="m0,0v186.94h197.14V0H0Zm112.86,49.8s.04.04.05.06c.7.83.45,3.02-.1,4.25-8.49,18.91-17.11,37.77-25.68,56.64-1.58,3.48-3.07,7-4.48,10.21,7.6.3,14.93.76,22.27.84,11.62.13,23.24-.07,34.86.08,1.65.02,3.68.8,4.87,1.93,1.06,1,2.11,2.02,3.14,3.06,3.1,3.1,6.09,6.31,9.14,9.45-.12.31-.24.62-.36.92-32.62.02-65.23.04-98.48.06,0,0,0,0,0-.01h-.01c14.97-32.94,29.67-65.28,44.62-98.16,3.73,3.85,7.15,7.1,10.16,10.67Zm69.26,114.09c-54.99.02-109.98.05-165.58.07C38.68,115.26,60.53,67.2,82.55,18.76c4.01,4.13,7.69,7.93,11.56,11.9-17.7,38.93-35.45,78-53.49,117.68,2.08.08,3.51.19,4.94.19,39.99-.01,79.97-.06,119.96.04,1.75,0,3.87.95,5.17,2.16,4.14,3.87,7.97,8.07,11.93,12.14-.18.35-.34.69-.5,1.02Z"
                            />
                        </svg>
                    </div>
                    
                    <div className="mb-6">
                        <h2 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                            Welcome to LineLeaders!
                        </h2>
                        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                            Thanks for subscribing. Get ready to elevate your betting game!
                        </p>
                    </div>
                    
                    <div className="space-y-4 mb-8">
                        <p className="text-sm text-gray-500 dark:text-gray-400">
                            Your premium access includes:
                        </p>
                        <ul className="text-left space-y-3">
                            <li className="flex items-center text-gray-900 dark:text-white justify-center">
                                <svg className="h-5 w-5 text-[#db0632] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                Advanced betting analytics
                            </li>
                            <li className="flex items-center text-gray-900 dark:text-white justify-center">
                                <svg className="h-5 w-5 text-[#db0632] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                Custom system building tools
                            </li>
                            <li className="flex items-center text-gray-900 dark:text-white justify-center">
                                <svg className="h-5 w-5 text-[#db0632] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                Real-time odds tracking
                            </li>
                        </ul>
                    </div>
                    
                    <PrimaryBtn 
                        text="Start Building Your Systems"
                        onClick={() => navigate("/systems")}
                        className="w-full"
                    />
                </div>
            </div>
        </AuthLayout>
    );
};

export default Subscribed;

